import React from 'react'
import Container from '../atoms/Container'
import Title from '../atoms/Title'
import classNames from 'classnames'

export default function Charcard({title, content,charRole,charIntro, ...rest}) {
const inside_container_classes = classNames('bg-ed-400',{
'mx-[10px] pb-6 md:pb-4':charIntro,
'mx-[18px] ms-[24px] pb-6 md:pb-4':charRole
})
const titleclasses = classNames('',{
'text-start  py-[14px]':charIntro,
'text-start  py-[16px] mb-[10px]':charRole
})
const contentclasses = classNames('',{
  'font-cairo-regular text-xs md:text-lg text-start':charIntro || charRole,
  })
  return (
        <Container bgColor className='h-fit my-3 flex-grow'>
            <div className={inside_container_classes}>

                    <div className={titleclasses}>
                        <Title {...rest}>{title}</Title>
                    </div>
                    <div className={contentclasses}>
                        {content}
                    </div>
            </div>
          
        </Container>
  )
}
